module.exports = __webpack_public_path__ + "img/comprehensiveBanner2.1c828c16.png";